import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import getJsUTC from "../../helpers/getJsUTC";
import HelperForMetaData from "../../helpers/HelperForMetaData";

const UpdateProperty = async (propertyId, e, oldImages) => {
  try {
    const PropertiesCollection = await doc(db, "properties", propertyId);
    const data = {
      ...e,
      modifiedAt: getJsUTC(),
      modifiedBy: getAuth().currentUser.uid,
      propertyStatus: "available",
      ...HelperForMetaData(),
    };
    delete data.createdAt;
    delete data.modifiedAt;

    await updateDoc(PropertiesCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default UpdateProperty;
